<template>
  <v-card outlined class="mx-6">
    <v-card-title class="d-flex justify-space-between align-start">
      <div>
        <h5 class="mb-1" style="text-transform: none !important;">{{ toProfession.professionName }}</h5>
        <h6 class="grey-text mb-0"  style="text-transform: none !important; font-size: 16px !important">{{ toProfession.professionType }}</h6>
      </div>
      <v-btn outlined @click="$emit('edit',toProfession)"><v-icon class="mr-2">$sl-edit</v-icon><div class="mr-4">Ändra</div></v-btn>
    </v-card-title>
    <v-card-text class="mt-0">
      <strong>Kurser som krävs vid grundutbildning för breddning till <span class="lower">{{ toProfession.professionName }}</span>:</strong><br/>
      <v-chip class="mr-2 mt-2" v-for="(course,i) in selectedCourses" :key="i">
      {{ course.name }}
    </v-chip>
    </v-card-text>
    <v-card-text class="mt-4">
      <strong>Kvalificeringstid:</strong> {{ qLength }}
    </v-card-text>
  </v-card>
</template>

<script>
import _get from 'lodash/get'
export default {
  props: {
    toProfession: Object
  },

  computed: {
    qLength() {
      const ql = _get(this, 'toProfession.data.length', null)
      return ql ? `${ql} månader` : 'Ej angiven'
    },

    selectedCourses() {
      const cs = _get(this, 'toProfession.data.requiredCourses', null)
      return cs ? cs : []
    }
  },

  methods: {
  }
}
</script>

<style scoped>
  .lower {
    text-transform: lowercase;
  }
</style>